module.exports = __webpack_public_path__ + "static/img/project-telecortex-inside-dome.e3921e5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project-telecortex-inside-dome.gif
// module id = LFe+
// module chunks = 0